module.exports = __webpack_public_path__ + "img/google-play-badge.2fe32523.png";